import React, { Component } from 'react';
import ModalWindow from './ModalWindow';

export class LkflModalContainer extends Component {
  state = {
    isVisible: false,
    content: null,
  };

  async show({ content }) {
    return new Promise((resolve, reject) => {
      this.onConfirm = (params) => {
        this.setState({ content: null, isVisible: false }, () => {
          resolve(params);
        });
      };
      this.onReject = (params) => {
        this.setState({ content: null, isVisible: false }, () => {
          reject(params);
        });
      };
      this.setState({ content: content(this.onConfirm, this.onReject), isVisible: true });
    });
  }

  async hide() {
    return new Promise((resolve) => {
      this.setState({ content: null, isVisible: false }, () => {
        resolve && resolve();
        this.onConfirm && this.onConfirm();
      });
    });
  }

  render() {
    let { isVisible, content } = this.state;
    return (
      <ModalWindow
        isVisible={isVisible}
        onConfirm={this.onConfirm}
        onReject={this.onReject}
        content={content}
      />
    );
  }
}
